import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import AboutUs from './components/AboutUs';
import Benefits from './components/Benefits';
import CTA from './components/CTA';
import Footer from './components/Footer';
import Breadcrumb from '../../components/Breadcrumb';

export default function HomePage() {
  useEffect(() => {
    // Page title
    document.title = 'Spray Foam Insulation Yuma AZ | Energy‑Saving Experts';

    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Professional spray foam insulation in Yuma, AZ. Reduce cooling costs 30‑50 %. Residential & commercial solutions. Free quotes. Call (928) 427‑8140.'
      );
    }

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', window.location.origin + '/');

    // Geo‑location tags
    const metaTags = [
      { name: 'geo.region', content: 'US-AZ' },
      { name: 'geo.placename', content: 'Yuma' },
      { name: 'geo.position', content: '32.6927;-114.6277' },
      { name: 'ICBM', content: '32.6927, -114.6277' },
    ];
    metaTags.forEach(tag => {
      let el = document.querySelector(`meta[name="${tag.name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', tag.name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', tag.content);
    });

    // Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'Spray Foam Insulation Yuma AZ | Energy‑Saving Experts' },
      {
        property: 'og:description',
        content:
          'Professional spray foam insulation in Yuma, AZ. Cut energy costs 30‑50 %. Residential & commercial services. Free quotes.'
      },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: window.location.origin + '/' },
      {
        property: 'og:image',
        content:
          'https://public.readdy.ai/ai/img_res/9a1d26f2860d2c266f0f34ea27e41c82.jpg'
      }
    ];
    ogTags.forEach(tag => {
      let el = document.querySelector(`meta[property="${tag.property}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', tag.property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', tag.content);
    });

    // Twitter Card tags
    const twitterTags = [
      { name: 'twitter:card', content: 'summary_large_image' },
      {
        name: 'twitter:title',
        content: 'Spray Foam Insulation Yuma AZ | Energy‑Saving Experts',
      },
      {
        name: 'twitter:description',
        content:
          'Professional spray foam insulation in Yuma, AZ. Reduce cooling costs 30‑50 %. Free quotes.',
      },
      {
        name: 'twitter:image',
        content:
          'https://readdy.ai/api/search-image?query=Modern%20minimalist%20architectural%20interior%20with%20clean%20geometric%20lines%20soft%20natural%20lighting%20and%20warm%20neutral%20tones%20creating%20elegant%20sophisticated%20atmosphere%20emphasizing%20comfort%20and%20energy%20efficiency%20in%20contemporary%20design%20Yuma%20Arizona&width=1200&height=630&seq=twitter-home-001&orientation=landscape',
      },
    ];
    twitterTags.forEach(tag => {
      let el = document.querySelector(`meta[name="${tag.name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', tag.name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', tag.content);
    });

    // Last‑modified tag
    let lastModified = document.querySelector('meta[name="last-modified"]');
    if (!lastModified) {
      lastModified = document.createElement('meta');
      lastModified.setAttribute('name', 'last-modified');
      document.head.appendChild(lastModified);
    }
    lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);

    // LocalBusiness schema
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'Yuma Spray Foam Insulation',
      telephone: '(928) 427-8140',
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 32.6927,
        longitude: -114.6277,
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
          opens: '08:00',
          closes: '18:00',
        },
      ],
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        reviewCount: '127',
      },
    };

    let scriptTag = document.querySelector('script[data-schema="home"]');
    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.setAttribute('type', 'application/ld+json');
      scriptTag.setAttribute('data-schema', 'home');
      document.head.appendChild(scriptTag);
    }
    scriptTag.textContent = JSON.stringify(schema);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Breadcrumb items={[{ label: 'Home' }]} />

      {/* Hero */}
      <Hero />

      {/* Services overview */}
      <Services />

      {/* About us section */}
      <AboutUs />

      {/* Benefits */}
      <Benefits />

      {/* Call‑to‑action */}
      <CTA />

      {/* Footer */}
      <Footer />
    </div>
  );
}